import styled, { css } from "styled-components";

const CardSideStyles = css`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 1.5rem 1.5rem 0.7rem 1.5rem;
  backface-visibility: hidden;
  transition: transform 1s ease-in-out;

  > div:first-child {
    height: 100%;
  }

  > div > p {
    padding-bottom: 0;
  }

  svg {
    width: 1.5rem;
    height: auto;
  }
`;

type TextAndFlipCardFlipCard = {
  $isFlipped: boolean;
};

export const TextAndFlipCardFlipCard = styled.button<TextAndFlipCardFlipCard>`
  flex-shrink: 0;
  position: relative;
  /* width: 400px; */
  /* height: 400px; */
  width: 100%;
  aspect-ratio: 1 / 1;
  height: auto;
  max-width: 400px;

  cursor: pointer;
  transition: 1s ease-in-out;
  transform-style: preserve-3d;
  transform: ${({ $isFlipped }) => !$isFlipped && "rotateY(0.5turn)"};
  text-align: left;

  &:hover,
  &:focus-visible {
    outline: 3px solid blue;
    outline-offset: 6px;
    border-radius: 6px;
  }
`;

type TextAndFlipCardFlipCardProps = {
  $backgroundImage?: string;
  $backgroundColor?: string;
};

export const CardFront = styled.div<TextAndFlipCardFlipCardProps>`
  background-color: ${({ $backgroundColor }) =>
    $backgroundColor && $backgroundColor};
  background-image: ${({ $backgroundImage }) => `url(${$backgroundImage})`};
  ${CardSideStyles}
  overflow: hidden;
`;

export const CardBack = styled.div<TextAndFlipCardFlipCardProps>`
  background-color: ${({ $backgroundColor }) =>
    $backgroundColor && $backgroundColor};
  background-image: ${({ $backgroundImage }) => `url(${$backgroundImage})`};
  ${CardSideStyles}
  transform: rotateY(0.5turn);
`;
